import { useGetUserData } from "../helpers/queries/user/useGetUserData";

const useGetUserRole = () => {
  const { data: user, isLoading } = useGetUserData();
  const role = user?.user?.role;
  const viewer = role === "Viewer";
  const editor = role === "Editor";
  const admin = role === "Admin";
  return { role, isLoading, viewer, editor, admin };
};

export { useGetUserRole };
